const LABEL_KEYS = {
  AGOTADO: 'soldOut',
  NUEVO: 'new',
  NUEVA: 'new',
  LIMITADO: 'limited',
  'MÁS VENDIDO': 'bestSeller',
  'MAS VENDIDO': 'bestSeller',
  OFERTA: 'sale',
};

export const translateLabel = (text, t) => {
  const key = LABEL_KEYS[(text || '').trim().toUpperCase()];
  return key ? t(`products.labels.${key}`) : text;
};
